export default __webpack_public_path__ + "static/media/voice-assistant.c32d152e.png";